export default __webpack_public_path__ + "static/media/icons8-unread-messages-right-more.deb1fbd2.svg";